export default function connectionQuality<T>(onHigh: T, onSlow: T): T {
  const { connection } = navigator as {
    connection?: { effectiveType?: 'slow-2g' | '2g' | '3g' | '4g' };
  };
  return connection?.effectiveType === '4g' ? onHigh : onSlow;
}
